<h1 class="titles">
  <span>3/4</span> ÐÐ°Ð³ÑÑÐ·ÐºÐ° ÑÐ°Ð¹Ð»Ð¾Ð²
</h1>

<arm-dropdown-block [validSubscribe]="validSubscription"></arm-dropdown-block>

<lib-button [disabled]="buttonDisable" (click)="nextStep()">ÐÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ</lib-button>
